import { render, staticRenderFns } from "./SearchAmenities.vue?vue&type=template&id=6b483a8a&scoped=true"
import script from "./SearchAmenities.vue?vue&type=script&lang=js"
export * from "./SearchAmenities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b483a8a",
  null
  
)

export default component.exports